import { Common } from './Common';

export class ElectionMember extends Common {
    election_id: string;
    vote_to: string;
    vote_date: Date;
    member_id: string; // Committee Member id
    type: string;
    status: string;
    role: string; // 'Voter', 'Candidate', 'Winner', 'Organizer'
}